/**
 * RoleIcon — tuile illustrée de rôle pour les médailles de l'accueil.
 *
 * v4.55 (choix fondateur, feuille « illustrations chaleureuses » — Higgsfield) :
 * personnages sénégalais en illustration plate chaude (vert #15803d / or
 * #d4a017 / crème), chaque tuile PORTE son propre cadre (fond crème, liseré
 * or, ombre douce) — générée en 1024×1024, servie en WebP léger.
 *
 * Concepts (alignés PRD § 4.0 & rôles) :
 *   - parrain_grand : aîné en boubou or, bras ouverts, entourage mobilisé,
 *     GRANDE étoile rayonnante → influence, soft power, ancre communautaire.
 *   - relais_prive  : jeune agent, sacoche verte, chemin vers une porte →
 *     l'accompagnateur de confiance, porte-à-porte.
 *   - relais_public : femme au mégaphone au marché → visible et contactable.
 *   - parrain_sympa : main sur le cœur, cœur d'or offert vers les personnes
 *     soutenues (badge vérifié) → le soutien solidaire des dossiers prouvés.
 *   - beneficiaire  : jeune homme (~20 ans) brandissant fièrement sa carte
 *     d'électeur cochée → le but de l'app : « Inscrit ».
 *
 * Purement décoratif — le parent porte l'aria (alt vide).
 */

const TILES = {
  parrain_grand: '/assets/images/roles/parrain-grand.webp',
  relais_prive: '/assets/images/roles/relais-prive.webp',
  relais_public: '/assets/images/roles/relais-public.webp',
  parrain_sympa: '/assets/images/roles/parrain-sympa.webp',
  beneficiaire: '/assets/images/roles/beneficiaire.webp',
};

function RoleIcon({ role, className = '' }) {
  return (
    <img
      className={`role-tile ${className}`.trim()}
      src={TILES[role] || TILES.beneficiaire}
      alt=""
      loading="lazy"
      decoding="async"
      aria-hidden="true"
    />
  );
}

export default RoleIcon;
